
import { Component, Vue } from "nuxt-property-decorator";
import ContentPageLayout from "~/components/molecules/display/ContentPageLayout.vue";
import { generateMetaTags } from "~/operations/meta-helper-functions";
import type { JumpNavItem } from "~/types/ContentPage";

@Component({
  scrollToTop: true,
  components: {
    ContentPageLayout,
  },
})
export default class PelletpreisZusammensetzung extends Vue {
  head() {
    return {
      ...generateMetaTags(
        this.$route.path,
        "holzpellets-preis-zusammensetzung",
      ),
      link: [{ rel: "canonical", href: this.$route.path }],
    };
  }

  get jumpNavItems(): JumpNavItem[] {
    return [
      {
        name: "Hauptkostenfaktoren im Überblick",
        title: "Springen Sie zum Bereich: Hauptkostenfaktoren",
        href: { hash: "#anker-hauptkosten" },
      },
      {
        name: "Externe Preistreiber und Marktfaktoren",
        title: "Springen Sie zum Bereich: Externe Preistreiber",
        href: { hash: "#anker-marktfaktoren" },
      },
      {
        name: "Qualitätsunterschiede und ihr Einfluss auf den Preis",
        title: "Springen Sie zum Bereich: Qualitätsunterschiede",
        href: { hash: "#anker-qualitaet" },
      },
      {
        name: "Tipps für den optimalen Pelletkauf",
        title: "Springen Sie zum Bereich: Tipps für den Kauf",
        href: { hash: "#anker-tipps" },
      },
      {
        name: "Marktprognosen und Trends",
        title: "Springen Sie zum Bereich: Marktprognosen & Trends",
        href: { hash: "#anker-trends" },
      },
      {
        name: "Transparenz schafft Planungssicherheit",
        title: "Springen Sie zum Bereich: Transparenz & Fazit",
        href: { hash: "#anker-transparenz" },
      },
      {
        name: "Preisvergleich",
        title: "Springen Sie zum Bereich: Preisvergleich",
        href: { hash: "#anker-preisvergleich" },
      },
    ];
  }
}
